// src/components/Layout/Layout.tsx
import React from "react";
import MenuBar from "../MenuBar/MenuBar";

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <>
      <MenuBar />
      <main>{children}</main>
    </>
  );
};

export default Layout;
